module.exports = __webpack_public_path__ + "static/media/translatorHeroImg.78edae03.webp";